'use client';

/* Built In Imports */
import NextLink from 'next/link';
import { useContext } from 'react';

/* External Imports */
import { Box, useBreakpointValue, useMediaQuery } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import StyleConfig from '@msr/Common/StyleConfig';

/* Services */
import { RegionContext } from '@msr/store/region-context';

// Utils
import { canRenderContent } from '@msr/components/Utility/utils';

/**
 *
 * @param section.section
 * @param {object} section
 * @param section.region
 * @param section.sectionContent
 * @param section.lang
 * @returns
 */
const Introduction = ({ section, region, sectionContent, lang }) => {
  const flexAlign =
    typeof window !== 'undefined' &&
    useBreakpointValue(
      {
        base: 'center',
        md: 'flex-start',
      },
      {
        ssr: false,
      }
    );
  const [isLargerThan768] = useMediaQuery('(min-width: 768px)');

  const currRegion = useContext(RegionContext);
  const secRegion = section?.region?.toLowerCase();
  const renderContent = canRenderContent(
    currRegion,
    secRegion,
    section?.sectionContent
  );
  return (
    <>
      {isLargerThan768 ? (
        <StyleConfig
          id={section.sectionId}
          key={section.sectionId}
          style={section.styleConfig}
          pT="30px"
          pB="0"
          mB="0"
          section={section}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          backgroundPosition="center"
          region={region}
          bgColor="#03062C"
        >
          <Box pt="30px">
            <RenderInfo
              sectionContent={sectionContent}
              flexAlign={flexAlign}
              isLargerThan768={isLargerThan768}
              lang={lang}
            />
          </Box>
        </StyleConfig>
      ) : (
        renderContent && (
          <Box bgColor="#03062C" p="60px 20px">
            <RenderInfo
              sectionContent={sectionContent}
              flexAlign={flexAlign}
              isLargerThan768={isLargerThan768}
              lang={lang}
            />
          </Box>
        )
      )}
    </>
  );
};

const RenderInfo = ({ sectionContent, flexAlign, isLargerThan768, lang }) => {
  return (
    <Box background={'#03062C'} justifyContent="center">
      <Box
        maxW={'820px'}
        width={{ base: '90%', md: '100%' }}
        color="white"
        textAlign={'center'}
        m={{ base: '0px auto', md: '0px auto' }}
        pb="20px"
      >
        <LazyLoadImageComponent src={sectionContent[0]?.image?.url} />
        <StructuredTextParser
          str={render(sectionContent[1]?.body)}
          className="msrInfoTopBanner"
          fontFamily="FedraSansStd-book"
        />
      </Box>
      <style jsx global>
        {`
          #msr-intro-section-iii {
            margin: 30px auto 0 atuo;
          }
          #msr-intro-section-iii {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
          .msrInfoTopBanner p {
            text-align: center;
            font-size: 20px;
            line-height: 27px;
            font-style: italic;
            padding-top: 20px;
          }
          @media (max-width: 768px) {
            .msrInfoTopBanner p {
              font-size: 16px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Introduction;
